import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText, Link, ThemeProvider, createTheme } from '@mui/material';
import { Login, PersonAdd, Verified, VerifiedUser, Email, Lock, Save, Logout } from '@mui/icons-material';

const theme = createTheme({
  palette: {
    primary: { main: '#2196f3', light: '#64b5f6', dark: '#1976d2' },
    background: { default: '#f5f5f5', paper: '#ffffff' },
  },
  typography: { fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', h5: { fontWeight: 600 } },
  shape: { borderRadius: 8 },
});

const pages = [
  { path: '/sign-in', label: 'Sign In', icon: <Login color="primary" /> },
  { path: '/sign-up', label: 'Sign Up', icon: <PersonAdd color="primary" /> },
  { path: '/sign-up-confirm', label: 'Sign Up Confirm', icon: <Verified color="primary" /> },
  { path: '/verify-account', label: 'Verify Account', icon: <VerifiedUser color="primary" /> },
  { path: '/forgot-password', label: 'Forgot Password', icon: <Email color="primary" /> },
  { path: '/update-password', label: 'Update Password', icon: <Lock color="primary" /> },
  { path: '/profile', label: 'Update Profile', icon: <Save color="primary" /> },
  { path: '/sign-off', label: 'Sign Off', icon: <Logout color="primary" /> },
];

const AllPages: React.FC = () => (
  <ThemeProvider theme={theme}>
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', pt: 8, pb: 4 }}>
      <Paper elevation={6} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', width: { xs: '100%', sm: 400 }, maxWidth: '100%', mx: { xs: 2, sm: 'auto' }, background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)', borderRadius: 2 }}>
        <Typography component="h1" variant="h5" sx={{ mb: 3, color: 'primary.main', fontWeight: 600, textAlign: 'center' }}>
          All Pages (Testing Links)
        </Typography>
        <List>
          {pages.map(page => (
            <ListItem key={page.path}>
              <ListItemIcon>{page.icon}</ListItemIcon>
              <Link href={page.path} underline="hover" color="primary">
                <ListItemText primary={page.label} />
              </Link>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  </ThemeProvider>
);

export default AllPages; 